<template>

  <div class="hello">
    <div>
  <b-tabs content-class="mt-3">
    <b-tab title="Home" active>
      <h1>{{ msg }}</h1>
      <img src="@/assets/UCR_Icon_BluBG.png" alt="Vue.js PWA">
    </b-tab>
    <b-tab title="Integers"><integers/></b-tab>
    <b-tab title="Operators"><operators/></b-tab>
    <b-tab title="Masking"><masking/></b-tab>
    <b-tab title="Signed Integers"><signed/></b-tab>
    <b-tab title="IEEE 754"><ieee754/></b-tab>
    <b-tab title="Truth Tables"><truthTables/></b-tab>
  </b-tabs>
</div>
  </div>
</template>

<script>
import ieee754 from '@/components/ieee754'
import integers from '@/components/integers'
import signed from '@/components/signed'
import operators from '@/components/operators'
import masking from '@/components/masking'
import truthTables from '@/components/truth-tables'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to CS061 Machine Organization and Assembly Language Programming Tutorials'
    }
  },
  components: {
    ieee754,
    integers,
    signed,
    operators,
    masking,
    truthTables
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #003DA5;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue